/*@flow*/
import * as t from 'lib/t';
import { Id } from 'types/tcomb';
import enumsFor from './util/enumsFor';
import mkTagTemplate from 'lib/templates/mkTagTemplate';

const config = {
  id: t.maybe(Id).opt({ type: 'hidden' }),
  name: t.String,
  contactType: t.maybe(t.list(t.String)).opt({
    label: 'Contact Type',
    template: 'ContactTypes',
    attrs: {
      placeholder: 'Choose or create a contact type',
    },
    extraProps: { isMulti: true },
    noOptionsMessage: 'Type and create a new contact type.',
  }),
  tags: t.maybe(t.list(t.String)).opt({
    template: mkTagTemplate('contacts'),
    attrs: {
      placeholder: 'Select...',
    },
  }),
  photoUrls: t.maybe(t.list(t.String)).options({
    label: 'Photo(s)',
    template: 'PhotoUploaderTemplate',
    help: 'Photos must be larger than 600px wide.',
  }),
  visibility: enumsFor('visibility'),
  organizationName: t.maybe(t.String),
  mailingAddress: t.maybe(t.String).opt({ template: 'AddressTemplate' }),
  email: t.maybe(t.String),
  phone: t.maybe(t.String),
  cellPhone: t.maybe(t.String),
  homePhone: t.maybe(t.String),
  fax: t.maybe(t.String),
  city: t.maybe(t.String),
  zip: t.maybe(t.String),
  stateOrProvince: t.maybe(t.String),
  title: t.maybe(t.String),
  notes: t
    .maybe(t.String)
    .opt({ template: 'TextEditorTemplate', type: 'textarea' }),
  propertyAddress: t.maybe(t.String).opt({
    before: {
      tag: 'h3',
      props: {
        children: 'Primary Location',
      },
    },
    label: 'Address',
    template: 'LocationPickerTemplate',
  }),
  theGeom: t.maybe(t.String).opt({ type: 'hidden' }),
  mapLabel: t.maybe(t.String),
  propertyLotId: t.maybe(t.String).opt({ label: 'Lot Id' }),
  propertyCity: t.maybe(t.String).opt({ label: 'City' }),
  propertyCountryAbbr: t.maybe(t.String).opt({ label: 'Country Abbreviation' }),
};

export default t.struct(config, 'Contact').opt<any>({ legend: '' });
